export const PATHS = {
    ROOT: 'asset-management',
    ASSET_MODELS: 'asset-models',
    VEHICLES: 'vehicles',
    VEHICLE_TYPES: 'vehicletypes',
    EQUIPMENT: 'equipment',
    DOCUMENTATION: 'documentation',
    EVENTS: 'events',
    STOCK_AVAILABILITY: 'stockavailability',
    // STOCK_AVAILABILITY_PREVIEW: '/stockavailability/',
}